/** see https://kentcdodds.com/blog/get-a-catch-block-error-message-with-typescript
 * In Javascript, there are no guarantees that a caught Error will contain a string message or
 * that it will even be an Error type.  This library attempts a best effort to coerce the error
 * of type 'unknown', and to return a string message from the unknown error.
 */

type ErrorWithMessage = {
  message: string
}

function isErrorWithMessage(error: unknown): error is ErrorWithMessage {
  return (
    typeof error === 'object'
    && error !== null
    && 'message' in error
    && typeof (error as Record<string, unknown>).message === 'string'
  );
}

function toErrorWithMessage(maybeError: unknown): ErrorWithMessage {
  if (isErrorWithMessage(maybeError)) { return maybeError; }

  try {
    return new Error(JSON.stringify(maybeError));
  } catch {
    return new Error(String(maybeError));
  }
}

export default function getErrorMessage(error: unknown): string {
  return toErrorWithMessage(error).message;
}
